module.exports = __webpack_public_path__ + "static/media/b-sci-major-33_LR.00521035.jpg";